import { SvgIcon, makeStyles } from "@material-ui/core"
import clsx from "clsx"

const useStyles = makeStyles({
  custom: {
    fill: "none !important",
    fontSize: "inherit !important",
    position: "relative",
    top: "3px",
    right: "2px"
  }
})

const NCSvgIcon = props => {
  const cls = useStyles()
  // eslint-disable-next-line no-unused-vars
  const { inheritViewBox, ...rest } = props
  return <SvgIcon {...rest} className={clsx(cls.custom, props.className)} />
}

export default NCSvgIcon
